export default __webpack_public_path__ + "static/media/sh-login-bg-gray.585478ae.png";